import type { FC } from 'react';
import React from 'react';
import cn from 'classnames';

import type { TSuccessSendLayout } from './models';

const fontSizeDesktop = 30;
const fontSizeMobile = 22;
const lineHeightDesktop = 36;
const lineHeightMobile = 26;

export const SuccessSendLayout: FC<TSuccessSendLayout> = ({
    Aligner,
    IconSuccess,
    Text,
    isMobile,
    styles,
}) => {
    const fontSize = isMobile ? fontSizeMobile : fontSizeDesktop;
    const lineHeight = isMobile ? lineHeightMobile : lineHeightDesktop;

    return (
        <Aligner className={cn(styles.external, styles.wrapper)}>
            <IconSuccess className={cn(styles.external, styles.icon)} />
            <Text
                className={cn(styles.external, styles.title)}
                fontSize={fontSize}
                fontWeight={7}
                lineHeight={lineHeight}
                tag="h2"
            >
                Заявка принята
            </Text>
            <Text className={cn(styles.external, styles.subtitle)}>
                Свяжемся с вами в течение 3 рабочих часов
            </Text>
        </Aligner>
    );
};
